import { SET_BLOCKS, SET_PROGRAM } from ":mutations";
import {
  REQUEST_BLOCKS,
  ADD_PROGRAM_BLOCK,
  UPDATE_PROGRAM_BLOCK,
  SWAP_PROGRAM_BLOCKS,
  DELETE_PROGRAM_BLOCK,
  REQUEST_PROGRAM,
  ADD_PROGRAM_ITEM,
  UPDATE_PROGRAM_ITEM,
  DELETE_PROGRAM_ITEM
} from ":actions";

import http from ":http";

const state = {
  blocks: [],
  program: [],
  dates: {
    from: "",
    to: ""
  }
};

const mutations = {
  [SET_BLOCKS](state, { blocks }) {
    state.blocks = blocks;
  },

  [SET_PROGRAM](state, { program, from, to }) {
    state.program = program;
    state.dates.from = from;
    state.dates.to = to;
  }
};

const actions = {
  [REQUEST_BLOCKS]({ commit }) {
    return http
      .get("/program/blocks", {
        params: {
          page: 0,
          size: 100
        }
      })
      .then(response => commit(SET_BLOCKS, { blocks: response.data }));
  },

  [ADD_PROGRAM_BLOCK]({ dispatch }, { block }) {
    return http
      .post("/program/blocks", block)
      .then(() => dispatch(REQUEST_BLOCKS));
  },

  [UPDATE_PROGRAM_BLOCK]({ dispatch }, { id, block }) {
    return http
      .patch(`/program/blocks/${id}`, block)
      .then(() => dispatch(REQUEST_BLOCKS));
  },

  [SWAP_PROGRAM_BLOCKS]({ dispatch }, { swap }) {
    return http
      .post("/program/blocks/swaps", swap)
      .then(() => dispatch(REQUEST_BLOCKS));
  },

  [DELETE_PROGRAM_BLOCK]({ dispatch }, { id }) {
    return http
      .delete(`/program/blocks/${id}`)
      .then(() => dispatch(REQUEST_BLOCKS));
  },

  [REQUEST_PROGRAM]({ commit }, { from, to }) {
    return http
      .get("/program", {
        params: { from, to }
      })
      .then(response =>
        commit(SET_PROGRAM, { program: response.data.program, from, to })
      );
  },

  [ADD_PROGRAM_ITEM]({ dispatch, state }, { item }) {
    return http
      .post("/program", {
        ...item,
        timeZone: "Europe/Warsaw" // todo: improve automatic detection of time zone?
      })
      .then(() =>
        dispatch(REQUEST_PROGRAM, {
          from: state.dates.from,
          to: state.dates.to
        })
      );
  },

  [UPDATE_PROGRAM_ITEM]({ dispatch, state }, { id, item }) {
    return http
      .patch(`/program/${id}`, {
        ...item,
        timeZone: "Europe/Warsaw" // todo: improve automatic detection of time zone?
      })
      .then(() =>
        dispatch(REQUEST_PROGRAM, {
          from: state.dates.from,
          to: state.dates.to
        })
      );
  },

  [DELETE_PROGRAM_ITEM]({ dispatch, state }, { id }) {
    return http.delete(`/program/${id}`).then(() =>
      dispatch(REQUEST_PROGRAM, {
        from: state.dates.from,
        to: state.dates.to
      })
    );
  }
};

const getters = {
  programBlocks: state =>
    state.blocks.reduce((acc, block) => {
      acc[block.id] = block;
      return acc;
    }, {})
};

export default {
  state,
  mutations,
  actions,
  getters
};
